<template>
	<div v-if="store.currentEpisode" class="h-full flex flex-row items-center justify-center">
		<audio
			class="hidden"
			ref="audioElement" 
			:src="store.currentEpisode.url"
			@timeupdate="onTimeUpdate"
			@loadedmetadata="onMetadataLoaded"
		></audio>
		
		<router-link
			:to="`/podcasts/${store.currentPodcast.id}/episode/${store.currentEpisode.linkid}`"
			class="h-18 md:w-84 flex flex-row items-center gap-3 border-r border-dark-blue"
		>
			<figure class="size-16 md:size-18">
				<img class="h-full" :src="store.currentPodcast.icon">
			</figure>
			<div class="hidden md:flex flex-1 mr-3 flex flex-col">
				<span class="text-sm line-clamp-1 leading-tight">{{ store.currentEpisode.name }}</span>
				<span class="text-xs line-clamp-1 leading-tight">{{ store.currentPodcast.name }}</span>
			</div>
		</router-link>
		
		<div class="flex-1 flex flex-row gap-6 px-6">
		
			<div class="flex-1 md:flex-0 flex flex-row justify-between gap-6 items-center">
				<button @click="skip(-15)" class="cursor-pointer hover:opacity-25">
					<svg class="size-6 md:size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00026 6.93055C4.00026 7.20284 4.22719 7.42357 4.50714 7.42357L9.06905 7.42357C9.349 7.42357 9.57593 7.20284 9.57593 6.93055C9.57593 6.65826 9.349 6.43752 9.06905 6.43752L5.88129 6.43752C9.11426 4.16809 13.6532 4.44864 16.5633 7.27917C19.7935 10.4211 19.7935 15.5152 16.5633 18.6572C13.3331 21.7991 8.0958 21.7991 4.86555 18.6572C4.66761 18.4646 4.34667 18.4646 4.14872 18.6572C3.95077 18.8497 3.95077 19.1619 4.14872 19.3544C7.77486 22.8814 13.654 22.8814 17.2801 19.3544C20.9063 15.8274 20.9063 10.1089 17.2801 6.58193C13.93 3.3234 8.6569 3.07534 5.01402 5.83776L5.01402 2.49333C5.01402 2.22104 4.78708 2.00031 4.50714 2.00031C4.22719 2.00031 4.00026 2.22104 4.00026 2.49333L4.00026 6.93055ZM10.388 10.5676H13.6629V9.89497H9.60427V13.3252H10.4067C10.5186 13.0785 10.6959 12.8852 10.9385 12.7451C11.1873 12.5993 11.4765 12.5265 11.8062 12.5265C12.2913 12.5265 12.6583 12.647 12.9071 12.888C13.1559 13.1234 13.2803 13.4597 13.2803 13.8969C13.2803 14.334 13.1559 14.6871 12.9071 14.9562C12.6583 15.2196 12.2882 15.3513 11.7968 15.3513C11.3988 15.3513 11.0691 15.2617 10.8079 15.0823C10.5466 14.9029 10.3756 14.6535 10.2947 14.334H9.46432C9.5514 14.8385 9.79709 15.242 10.2014 15.5447C10.6057 15.8474 11.1344 15.9987 11.7875 15.9987C12.2976 15.9987 12.7236 15.9062 13.0657 15.7213C13.4141 15.5363 13.6722 15.2841 13.8401 14.9646C14.0081 14.6451 14.0921 14.2836 14.0921 13.88C14.0921 13.5381 14.0205 13.2159 13.8775 12.9132C13.7406 12.6049 13.5105 12.3555 13.187 12.165C12.8636 11.9688 12.4437 11.8707 11.9275 11.8707C11.604 11.8707 11.3024 11.9295 11.0224 12.0472C10.7425 12.1593 10.5311 12.3051 10.388 12.4844V10.5676ZM5.72511 9.90338V10.6012H6.6208V15.9819H7.47917V9.90338H5.72511Z" fill="currentColor"/>
					</svg>

				</button>
				
				<button @click="store.playPreviousEpisode()" class="cursor-pointer hover:opacity-25">
					<svg class="size-6 md:size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2.5C3 2.22386 2.77614 2 2.5 2C2.22386 2 2 2.22386 2 2.5V21.5001C2 21.7762 2.22386 22.0001 2.5 22.0001C2.77614 22.0001 3 21.7762 3 21.5001V2.5ZM18.409 4.54539C18.9754 4.24539 19.6467 4.2558 20.1737 4.48334C20.7048 4.71266 21 5.11271 21 5.53988V18.4798C21 18.9114 20.7021 19.3131 20.1685 19.5417C19.6389 19.7686 18.9651 19.7761 18.3989 19.4715L6.27888 12.9508L6.27887 12.9508C5.78276 12.6839 5.58988 12.2945 5.5913 11.9568C5.59272 11.6189 5.78913 11.23 6.28794 10.9657M22 5.53988C22 4.59542 21.3452 3.89989 20.5701 3.56525C19.7908 3.22882 18.7996 3.20688 17.941 3.6617L17.941 3.66171L5.81982 10.082L5.81978 10.0821C5.0404 10.495 4.59448 11.1973 4.59131 11.9526C4.58814 12.7081 5.02842 13.4136 5.80509 13.8315L5.8051 13.8315L17.9252 20.3521C18.784 20.8142 19.7792 20.7963 20.5623 20.4609C21.3415 20.1271 22 19.4294 22 18.4798V5.53988Z" fill="#110D2B"/>
					</svg>
				</button>
				
				<button @click="store.togglePlay()" class="cursor-pointer hover:opacity-25">
					<svg  v-if="store.isPlaying" class="size-9 md:size-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.05961 7.5C9.33575 7.5 9.55961 7.72386 9.55961 8V15.8577C9.55961 16.1338 9.33575 16.3577 9.05961 16.3577C8.78347 16.3577 8.55961 16.1338 8.55961 15.8577V8C8.55961 7.72386 8.78347 7.5 9.05961 7.5ZM15.5596 8C15.5596 7.72386 15.3358 7.5 15.0596 7.5C14.7835 7.5 14.5596 7.72386 14.5596 8V15.8577C14.5596 16.1338 14.7835 16.3577 15.0596 16.3577C15.3358 16.3577 15.5596 16.1338 15.5596 15.8577V8Z" fill="currentColor"/>
					</svg>
					<svg  v-if="!store.isPlaying" class="size-9 md:size-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.97742 7.86322C8.97742 7.40527 9.52525 7.08339 9.96072 7.36795L9.96083 7.36802L16.3404 11.5344L16.3403 11.5345L16.3478 11.5392C16.5101 11.6411 16.6141 11.8266 16.6133 12.032C16.6126 12.2375 16.5072 12.4221 16.3443 12.5226L16.3442 12.5226L16.3364 12.5276L9.95682 16.6335L9.95665 16.6336C9.5207 16.9144 8.97742 16.5942 8.97742 16.1354V7.86322ZM7.97742 7.86322C7.97742 6.56806 9.44312 5.83526 10.5076 6.53076L10.5077 6.53083L16.8838 10.6949C17.3422 10.9849 17.6153 11.494 17.6133 12.0358C17.6113 12.5774 17.3345 13.0844 16.874 13.3708L10.4982 17.4743C9.43413 18.1597 7.97742 17.4299 7.97742 16.1354V7.86322Z" fill="#110D2B"/>
					</svg>

				</button>
				
				<button @click="store.playNextEpisode()" class="cursor-pointer hover:opacity-25">
					<svg class="size-6 md:size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M21 2.5C21 2.22386 21.2239 2 21.5 2C21.7761 2 22 2.22386 22 2.5V21.5001C22 21.7762 21.7761 22.0001 21.5 22.0001C21.2239 22.0001 21 21.7762 21 21.5001V2.5ZM5.59096 4.54539C5.0246 4.24539 4.35332 4.2558 3.8263 4.48334C3.29515 4.71266 2.99999 5.11271 2.99999 5.53988V18.4798C2.99999 18.9114 3.29793 19.3131 3.83148 19.5417C4.36114 19.7686 5.03489 19.7761 5.60106 19.4715L17.7211 12.9508L17.7211 12.9508C18.2172 12.6839 18.4101 12.2945 18.4087 11.9568C18.4073 11.6189 18.2109 11.23 17.7121 10.9657M1.99999 5.53988C1.99999 4.59542 2.65482 3.89989 3.42993 3.56525C4.20916 3.22882 5.20038 3.20688 6.05903 3.6617L6.05904 3.66171L18.1802 10.082L18.1802 10.0821C18.9596 10.495 19.4055 11.1973 19.4087 11.9526C19.4119 12.7081 18.9716 13.4136 18.1949 13.8315L18.1949 13.8315L6.07484 20.3521C5.216 20.8142 4.22077 20.7963 3.43771 20.4609C2.65852 20.1271 1.99999 19.4294 1.99999 18.4798V5.53988Z" fill="#110D2B"/>
					</svg>

				</button>
				
				<button @click="skip(15)" class="cursor-pointer hover:opacity-25">
					<svg class="size-6 md:size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M19.9997 6.93055C19.9997 7.20284 19.7728 7.42357 19.4929 7.42357L14.9309 7.42357C14.651 7.42357 14.4241 7.20284 14.4241 6.93055C14.4241 6.65826 14.651 6.43752 14.9309 6.43752L18.1187 6.43752C14.8857 4.16809 10.3468 4.44864 7.4367 7.27917C4.20645 10.4211 4.20645 15.5152 7.4367 18.6572C10.6669 21.7991 15.9042 21.7991 19.1344 18.6572C19.3324 18.4646 19.6533 18.4646 19.8513 18.6572C20.0492 18.8497 20.0492 19.1619 19.8513 19.3544C16.2251 22.8814 10.346 22.8814 6.71986 19.3544C3.09372 15.8274 3.09372 10.1089 6.71986 6.58193C10.07 3.3234 15.3431 3.07535 18.986 5.83776V2.49333C18.986 2.22104 19.2129 2.00031 19.4929 2.00031C19.7728 2.00031 19.9997 2.22104 19.9997 2.49333V6.93055ZM14.5699 10.5675H17.8447V9.89494H13.7861V13.3252H14.5885C14.7005 13.0786 14.8777 12.8852 15.1203 12.7451C15.3691 12.5993 15.6584 12.5265 15.988 12.5265C16.4732 12.5265 16.8402 12.647 17.089 12.888C17.3378 13.1234 17.4622 13.4597 17.4622 13.8969C17.4622 14.3341 17.3378 14.6872 17.089 14.9562C16.8402 15.2197 16.4701 15.3514 15.9787 15.3514C15.5806 15.3514 15.2509 15.2617 14.9897 15.0823C14.7285 14.903 14.5574 14.6536 14.4766 14.3341H13.6462C13.7333 14.8385 13.979 15.2421 14.3833 15.5447C14.7876 15.8474 15.3163 15.9987 15.9694 15.9987C16.4794 15.9987 16.9055 15.9063 17.2476 15.7213C17.5959 15.5363 17.854 15.2841 18.022 14.9646C18.1899 14.6451 18.2739 14.2836 18.2739 13.8801C18.2739 13.5382 18.2023 13.2159 18.0593 12.9132C17.9224 12.6049 17.6923 12.3555 17.3689 12.165C17.0454 11.9688 16.6256 11.8707 16.1093 11.8707C15.7859 11.8707 15.4842 11.9295 15.2043 12.0472C14.9244 12.1593 14.7129 12.3051 14.5699 12.4844V10.5675ZM9.90702 9.90335V10.6012H10.8027V15.9819H11.6611V9.90335H9.90702Z" fill="#110D2B"/>
					</svg>

				</button>
			</div>
	
			<div class="flex-1 hidden md:flex flex-col gap-3 px-6 pb-2 justify-center">
				<div class="w-full flex flex-row justify-between leading-tight">
					<span class="text-xs">{{ formatTime(currentTime) }}</span>
					<span class="text-xs">{{ formatTime(duration) }}</span>
				</div>
				<input 
					type="range" 
					min="0" 
					:max="duration || 100" 
					:value="currentTime" 
					@input="onSeek"
					class="w-full h-2 bg-white rounded-lg appearance-none cursor-pointer accent-black"
				/>
			</div>
			
			<div class="hidden md:flex flex-row gap-6 w-20 items-center">
				<button @click="copyTimestampLink" class="cursor-pointer hover:opacity-25 text-xs w-full flex flex-col justify-center items-center">
					<svg class="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M11.4995 2.14644L8.31273 5.32363C8.11718 5.5186 8.11718 5.8347 8.31273 6.02967C8.50829 6.22464 8.82535 6.22464 9.0209 6.02967L11.3528 3.70475V14.147C11.3528 14.4228 11.577 14.6463 11.8536 14.6463C12.1301 14.6463 12.3543 14.4228 12.3543 14.147L12.3543 3.70475L14.6863 6.02967C14.8818 6.22464 15.1989 6.22464 15.3944 6.02967C15.59 5.8347 15.59 5.5186 15.3944 5.32363L12.2077 2.14644C12.0121 1.95147 11.6951 1.95147 11.4995 2.14644ZM21 17.2874C21 17.6715 20.9959 18.6313 20.6327 19.4854C20.4544 19.9047 20.1979 20.2775 19.8307 20.5461C19.4681 20.8114 18.9638 21.0002 18.2429 21.0002L5.49997 21.0002C4.80511 21.0002 4.33172 20.8784 4.0046 20.7004C3.68563 20.5268 3.47387 20.2827 3.32651 19.9728C3.01015 19.3075 2.99996 18.3828 2.99996 17.2876L2.99996 8.73428C2.99996 8.45814 2.7761 8.23429 2.49996 8.23429C2.22382 8.23429 1.99996 8.45814 1.99996 8.73429L1.99996 17.2876L1.99995 17.3564C1.99973 18.3614 1.99947 19.5107 2.42341 20.4022C2.65105 20.8809 3.00179 21.2932 3.52658 21.5788C4.04321 21.8599 4.69482 22.0002 5.49997 22.0002L18.2429 22.0002C19.1505 22.0002 19.8676 21.7582 20.4211 21.3532C20.97 20.9517 21.3241 20.4149 21.553 19.8767C22.0001 18.8252 22 17.6894 22 17.2976L22 17.2874V8.73429C22 8.45814 21.7761 8.23429 21.5 8.23429C21.2239 8.23429 21 8.45814 21 8.73429V17.2874Z" fill="#110D2B"/>
					</svg>
					{{ linkCopied ? 'Kopierad!' : 'Dela tidskod' }}
				</button>
			</div>
		
		</div>
	</div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, watch, nextTick } from 'vue'
import { usePodcastStore } from '../stores/podcastStore'
import { useRoute } from 'vue-router'

const store = usePodcastStore()
const route = useRoute()

const audioElement = ref(null)
const currentTime = ref(0)
const duration = ref(0)
const linkCopied = ref(false)

// Variabel för att hålla koll på senaste sparade sekund (minskar trycket på localStorage)
let lastSavedSecond = 0

const onMetadataLoaded = () => {
	if (!audioElement.value) return
	duration.value = audioElement.value.duration
	
	// Prioritet 1: Om URL:en har en djuplänk (?t=X), använd den i första hand
	if (route.query.t) {
		const startTime = parseFloat(route.query.t)
		if (!isNaN(startTime) && startTime < duration.value) {
			audioElement.value.currentTime = startTime
			currentTime.value = startTime
			return
		}
	}

	// Prioritet 2: Annars kollar vi om det finns en historiskt sparad tid i vår Pinia store
	const savedTime = store.getSavedTimeById(store.currentEpisode.linkid)
	if (savedTime > 0 && savedTime < duration.value) {
		audioElement.value.currentTime = savedTime
		currentTime.value = savedTime
	}
}

const onTimeUpdate = () => {
	if (!audioElement.value) return
	
	const currentSecs = audioElement.value.currentTime
	currentTime.value = currentSecs

	// Spara bara positionen till localStorage en gång per sekund istället för vid varje frames-uppdatering
	const currentWholeSecond = Math.floor(currentSecs)
	if (currentWholeSecond !== lastSavedSecond) {
		lastSavedSecond = currentWholeSecond
		store.savePlaybackPosition(store.currentEpisode.linkid, currentSecs)
	}
}

const onSeek = (event) => {
	const newTime = parseFloat(event.target.value)
	if (audioElement.value) {
		audioElement.value.currentTime = newTime
		currentTime.value = newTime
		store.savePlaybackPosition(store.currentEpisode.linkid, newTime)
	}
}

const formatTime = (secs) => {
	if (isNaN(secs) || secs === Infinity) return '0:00'
	const minutes = Math.floor(secs / 60)
	const seconds = Math.floor(secs % 60)
	return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
}

const copyTimestampLink = async () => {
	const exactTime = Math.floor(currentTime.value)
	const podcastId = store.currentPodcast.id
	
	const sharedUrl = `${window.location.origin}/podcasts/${podcastId}/episode/${store.currentEpisode.linkid}?t=${exactTime}`
	
	try {
		await navigator.clipboard.writeText(sharedUrl)
		linkCopied.value = true
		setTimeout(() => linkCopied.value = false, 2500)
	} catch (err) {
		console.error("Webbläsaren blockerade urklippshanteringen:", err)
	}
}

const skip = (seconds) => {
	if (!audioElement.value) return
	
	let newTime = audioElement.value.currentTime + seconds
	
	// Förhindra att man spolar bakom start (0) eller förbi programmets slut
	if (newTime < 0) newTime = 0
	if (newTime > duration.value) newTime = duration.value
	
	// Uppdatera spelaren och din Vue-state direkt
	audioElement.value.currentTime = newTime
	currentTime.value = newTime
	
	// Spara den nya positionen direkt till din Pinia store
	store.savePlaybackPosition(store.currentEpisode.linkid, newTime)
}

watch(() => store.isPlaying, (shouldPlay) => {
	if (!audioElement.value) return
	if (shouldPlay) {
		audioElement.value.play().catch(() => store.isPlaying = false)
	} else {
		audioElement.value.pause()
	}
})

watch(() => store.currentEpisode, async (newEpisode) => {
	if (!audioElement.value || !newEpisode) return
	await nextTick()
	audioElement.value.load()
	
	// Nollställ spärren för sparande inför det nya spåret
	lastSavedSecond = 0

	if (store.isPlaying) {
		audioElement.value.play().catch(() => store.isPlaying = false)
	}
})
</script>
